import { createStyles, getStylesRef, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      position: 'relative',
      backgroundColor: '#fff',
      backgroundPosition: 'cover',
      backgroundRepeat: 'no-repeat',
      borderRadius: 16,
      border: `1px solid rgba(228, 232, 236, 0.5)`,
      padding: 16,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 16,
      transition: 'all .3s ease',
      overflow: 'hidden',
      [theme.fn.largerThan('sm')]: {
        borderRadius: 32,
        padding: '32px 32px 24px 32px',
        '&:hover': {
          transform: 'translateY(-10px)',
          // backgroundColor: theme.colors.yellow[0],
          [`.${getStylesRef('bg')}`]: {
            // opacity: 1,
            // transform: 'scale(1)',
          },
        },
      },
    },
    thumbnailFrame: {
      borderRadius: '100%',
      border: `1px solid ${theme.colors.neutral[1]}`,
      backgroundColor: theme.colors.neutral[0],
      width: 48,
      [theme.fn.largerThan('sm')]: {
        width: 72,
      },
    },
    thumbnail: {
      display: 'flex',
    },
    thumbnailImg: {
      maxWidth: 28,
      maxHeight: 28,
      [theme.fn.largerThan('sm')]: {
        maxWidth: 40,
        maxHeight: 40,
      },
    },
    heading: {
      fontSize: 18,
      lineHeight: rem(26),
      fontWeight: 600,
      [theme.fn.largerThan('sm')]: {
        fontSize: 22,
        lineHeight: '32px',
      },
    },
    info: {
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
    infoTop: {
      display: 'flex',
      gap: 16,
      [theme.fn.smallerThan('sm')]: {
        alignItems: 'center',
        justifyContent: 'space-between',
      },
      [theme.fn.largerThan('sm')]: {
        flexDirection: 'column',
      },
    },
    infoHead: {
      display: 'flex',
      gap: 13,
      [theme.fn.smallerThan('sm')]: { alignItems: 'center' },
      [theme.fn.largerThan('sm')]: {
        flexDirection: 'column',
      },
    },
    arrow: {
      flexGrow: 0,
      [theme.fn.largerThan('sm')]: {
        display: 'none',
      },
    },
    desc: {
      fontSize: 14,
      lineHeight: rem(22),
      color: '#595959',
      [theme.fn.largerThan('sm')]: {
        fontSize: 18,
        lineHeight: rem(28),
      },
    },
    btn: {
      position: 'relative',
      zIndex: 1,
      padding: 0,
      border: 0,
      fontWeight: 400,
      '&:hover, &:focus': {
        backgroundColor: 'transparent',
      },
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
    btnIcon: {
      marginLeft: 8,
    },
    bg: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 0,

      borderRadius: 'inherit',
    },
    bgImg: {
      ref: getStylesRef('bg'),
      opacity: 0,
      borderRadius: 'inherit',
      // transform: 'scale(0)',
      // transformOrigin: '50% 50%',
      transition: 'all .3s ease',
    },
  }
})
